import { DEFAULT_CDN_PATH, DEFAULT_HAS_INTERNAL_ASSETS } from './constants';

const cdn = {
  path: process.env.REACT_APP_CDN_PATH || DEFAULT_CDN_PATH,
  hasInternalAssets:
    (process.env.REACT_APP_HAS_INTERNAL_ASSETS || DEFAULT_HAS_INTERNAL_ASSETS) === 'yes'
};

export { cdn };
